import { RELATIONSHIP_OPTIONS } from './NextOfKinModal';

export const relationshipLabel = (value) => RELATIONSHIP_OPTIONS.find((o) => o.value === value)?.label || value;

export const primaryContact = (contacts = []) => contacts.find((c) => c.is_primary) || contacts[0] || null;
